// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPaymentRuleRenewalDto } from './IPaymentRuleRenewalDto';
import {
    IPaymentRuleRenewalDtoFromJSON,
    IPaymentRuleRenewalDtoFromJSONTyped,
    IPaymentRuleRenewalDtoToJSON,
    IPaymentRuleRenewalDtoToJSONTyped,
} from './IPaymentRuleRenewalDto';
import type { IServiceRenewalDto } from './IServiceRenewalDto';
import {
    IServiceRenewalDtoFromJSON,
    IServiceRenewalDtoFromJSONTyped,
    IServiceRenewalDtoToJSON,
    IServiceRenewalDtoToJSONTyped,
} from './IServiceRenewalDto';

/**
 * 
 * @export
 * @interface IServiceConfigRenewalDto
 */
export interface IServiceConfigRenewalDto {
    /**
     * 
     * @type {Array<IServiceRenewalDto>}
     * @memberof IServiceConfigRenewalDto
     */
    services?: Array<IServiceRenewalDto>;
    /**
     * 
     * @type {number}
     * @memberof IServiceConfigRenewalDto
     */
    claim_value?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IServiceConfigRenewalDto
     */
    is_applied_deductible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IServiceConfigRenewalDto
     */
    payment_type?: string;
    /**
     * 
     * @type {Array<IPaymentRuleRenewalDto>}
     * @memberof IServiceConfigRenewalDto
     */
    payment_rules?: Array<IPaymentRuleRenewalDto>;
    /**
     * 
     * @type {string}
     * @memberof IServiceConfigRenewalDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IServiceConfigRenewalDto interface.
 */
export function instanceOfIServiceConfigRenewalDto(value: object): value is IServiceConfigRenewalDto {
    return true;
}

export function IServiceConfigRenewalDtoFromJSON(json: any): IServiceConfigRenewalDto {
    return IServiceConfigRenewalDtoFromJSONTyped(json, false);
}

export function IServiceConfigRenewalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IServiceConfigRenewalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(IServiceRenewalDtoFromJSON)),
        'claim_value': json['claim_value'] == null ? undefined : json['claim_value'],
        'is_applied_deductible': json['is_applied_deductible'] == null ? undefined : json['is_applied_deductible'],
        'payment_type': json['payment_type'] == null ? undefined : json['payment_type'],
        'payment_rules': json['payment_rules'] == null ? undefined : ((json['payment_rules'] as Array<any>).map(IPaymentRuleRenewalDtoFromJSON)),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IServiceConfigRenewalDtoToJSON(json: any): IServiceConfigRenewalDto {
    return IServiceConfigRenewalDtoToJSONTyped(json, false);
}

export function IServiceConfigRenewalDtoToJSONTyped(value?: IServiceConfigRenewalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(IServiceRenewalDtoToJSON)),
        'claim_value': value['claim_value'],
        'is_applied_deductible': value['is_applied_deductible'],
        'payment_type': value['payment_type'],
        'payment_rules': value['payment_rules'] == null ? undefined : ((value['payment_rules'] as Array<any>).map(IPaymentRuleRenewalDtoToJSON)),
        'description': value['description'],
    };
}

